import React, {useState} from 'react';
import {Button} from "@material-ui/core";
import {Form, Formik} from "formik";
import FormInitialValues from "../Checkout/FormModel/formInitialValues";
import ValidationSchema from "../Checkout/FormModel/validationSchema";
import AdviserFormModel from "../Checkout/FormModel/formModel";
import useStyles from "./styles"
import Axios from 'axios';
import {useAuth0} from "@auth0/auth0-react";
import ValidatePassphraseSuccess from "./ValidatePassphraseSuccess";
import PassphraseForm from "./Forms/PassphraseForm";
import Loading from "../../../Loading";

const {formId, formField} = AdviserFormModel;

function _renderStepContent(step, validationResponse, setActiveStep) {
    switch (step) {
        case 0:
            return <PassphraseForm formField={formField}/>
        case 1:
            return <ValidatePassphraseSuccess validationResponse={validationResponse}
                                              goBack={() => setActiveStep(step - 1)}/>
        default:
            return <div>Not Found</div>;
    }
}

function CheckoutValidatePassphrase() {
    const classes = useStyles()
    const {getIdTokenClaims} = useAuth0();
    const [activeStep, setActiveStep] = useState(0);
    const currentValidationSchema = ValidationSchema[activeStep];
    const [validationResponse, setValidationResponse] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    async function _submitForm(values, actions) {
        const claims = await getIdTokenClaims();
        const id_token = claims.__raw;

        let url = process.env.REACT_APP_BACK_SERVER + '/validate-password'

        Axios.post(url, values, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${id_token}`,
            }
        }).then((result) => {
            setValidationResponse(result.data)
        }).finally(() => {
            setActiveStep(activeStep + 1);
            actions.setSubmitting(false);
            setIsLoading(false)
        });
    }

    function _handleSubmit(values, actions) {
        setIsLoading(true)
        _submitForm(values, actions);
    }

    return (
        <React.Fragment>
            <div style={{padding: "30px", display: "flex", flexDirection: "column"}}>
                <h2 className={classes.formTitle}>Registro de Asesores</h2>
                <React.Fragment>
                    <Formik
                        initialValues={FormInitialValues}
                        validationSchema={currentValidationSchema}
                        validateOnBlur={false}
                        onSubmit={_handleSubmit}
                    >
                        {({isSubmitting}) => (
                            <Form id={formId}>
                                {isLoading
                                    ? <Loading height={200}/>
                                    : _renderStepContent(activeStep, validationResponse, setActiveStep)
                                }
                                <div className={classes.buttons} style={{display: activeStep > 0 && "none"}}>
                                    <div className={classes.wrapper}>
                                        <Button
                                            disabled={isSubmitting}
                                            type="submit"
                                            variant="contained"
                                            className={classes.button}
                                        >
                                            Enviar
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </React.Fragment>
            </div>
        </React.Fragment>
    );
}

export default CheckoutValidatePassphrase;